import { createContext, useReducer, useContext } from 'react';
import { DragReducer, initial_state } from '../reducer';

const DragContext = createContext();

/**
 * React.useContext hook
 * @returns <DragContext>
 */
export function useDragContext() {
  const context = useContext(DragContext);
  if (typeof context === 'undefined') {
    throw new Error('useDragContext have to be used within DragContextProvider');
  }
  return context;
}

/**
 * React.createContext().Provider
 * @returns React.Provider<any>
 */
export function DragContextProvider({ children }) {
  const [state, dispatch] = useReducer(DragReducer, initial_state);
  return <DragContext.Provider value = {{ state, dispatch }}>{ children }</DragContext.Provider>
}